import React from 'react';
import './BlogHero.css';

function BlogHero() {
  return (
    <section className="blog-hero-section">
      <div className="blog-hero-overlay">
        <div className="blog-hero-content">
          <h1>Review Insights</h1>
          <p>Discover in-depth reviews, product trends, and expert recommendations.</p>
        </div>
      </div>
    </section>
  );
}

export default BlogHero;
